module.exports = __webpack_public_path__ + "static/media/tab0.cab72fb3.png";